import {DEFAULT_APP_VERSION} from '../const/const';

export function parseAppVersion(value) {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_APP_VERSION;
}
